import { AnyAction } from 'redux';

import { StateType } from '../../../../../states';
import { BasketState } from '../../../../../states/basket';
import recomputeNextMissionBasketState from '../../../../missions/utils/recomputeNextMissionBasketState';

/**
 * Set item freebetId as boolean to be use as freebet balance
 * @param  {Object} state        The actual state.
 * @param  {Object} action       The action to reduce.
 * @return {Object}              Return the new state.
 */
const basketItemSetKLEligibleCollectible = (state: BasketState, action: AnyAction, globalState: StateType) => {
  const { items } = state;
  const { oddsId, collectibleId } = action.payload;

  const item = items[oddsId];

  if (item && item.eligibleKLCollectibleId !== collectibleId) {
    const nextState = {
      ...state,
      items: {
        ...items,
        [oddsId]: {
          ...item,
          eligibleKLCollectibleId: collectibleId,
          selectedFreebetId: collectibleId ? undefined : item.selectedFreebetId,
        },
      },
    };

    return recomputeNextMissionBasketState(nextState, globalState);
  }

  return state;
};

export default basketItemSetKLEligibleCollectible;
